var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_46_3996)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_46_3996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60397 16.1846C5.79868 14.8324 5.79868 13.1676 6.60397 11.8154L10.8463 4.69169C11.6538 3.33566 13.1484 2.5 14.7661 2.5L23.2339 2.5C24.8516 2.5 26.3462 3.33566 27.1537 4.69169L31.396 11.8154C32.2013 13.1676 32.2013 14.8324 31.396 16.1846L27.1537 23.3083C26.3462 24.6643 24.8516 25.5 23.2339 25.5L14.7661 25.5C13.1484 25.5 11.6538 24.6643 10.8463 23.3083L6.60397 16.1846Z",
    fill: "#19191E"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4459 7.02563C21.3845 7.05675 20.9158 7.98821 19.3348 11.221C16.8914 16.2172 16.9501 16.0933 16.9105 16.3394C16.7702 17.2104 17.5863 18.0256 18.4472 17.8745C18.8879 17.7971 19.3006 17.4898 19.4709 17.112C19.5443 16.9493 21.7693 7.37608 21.7693 7.22313C21.7693 7.1396 21.6789 7.02911 21.5901 7.00402C21.5542 6.99388 21.4894 7.00359 21.4459 7.02563ZM18.907 8.29724C18.8525 8.36294 18.7581 10.1722 18.8062 10.2302C18.8324 10.2617 19.1664 10.3411 19.2732 10.3411C19.2983 10.3411 20.2376 8.44233 20.2376 8.39159C20.2376 8.36001 19.7788 8.3016 19.275 8.26898C19.0044 8.25148 18.941 8.25633 18.907 8.29724ZM17.7606 8.34254C16.5521 8.53929 15.4527 8.95753 14.5178 9.57618C14.0856 9.8622 14.06 9.88814 14.1123 9.98673C14.2226 10.1943 14.8373 11.0581 14.8747 11.0581C14.8983 11.0581 15.0989 10.9705 15.3206 10.8634C16.0645 10.5042 16.7985 10.3079 17.6375 10.2439C17.8755 10.2257 18.0943 10.2108 18.1238 10.2108C18.1533 10.2107 18.1848 10.1913 18.1939 10.1676C18.216 10.1101 18.1019 8.40417 18.0728 8.35714C18.0507 8.32142 17.9262 8.31559 17.7606 8.34254ZM21.5773 9.98523C21.4289 10.632 21.3125 11.1645 21.3184 11.1687C21.3244 11.1728 21.4273 11.2449 21.547 11.329C21.6668 11.413 21.7855 11.4818 21.8109 11.4818C21.8796 11.4818 21.9069 11.444 22.5495 10.4612C22.9344 9.87247 23.1386 9.53091 23.132 9.48678C23.1248 9.43881 23.0357 9.37255 22.8286 9.26119C22.5904 9.1332 21.8936 8.80928 21.8564 8.80928C21.8512 8.80928 21.7256 9.33846 21.5773 9.98523ZM23.7766 10.0396C23.3488 10.5242 22.2921 11.8376 22.2916 11.8854C22.2911 11.9191 22.3931 12.0545 22.5182 12.1862C23.0485 12.7444 23.51 13.5015 23.7876 14.2683C23.8793 14.5217 23.9198 14.5958 23.97 14.6015C24.0054 14.6055 24.6284 14.3701 25.3544 14.0785C26.4673 13.6314 26.6759 13.5374 26.6843 13.4794C26.7034 13.3486 26.2347 12.503 25.818 11.9165C25.5209 11.4982 25.0406 10.942 24.6985 10.6201C24.3905 10.3303 23.9287 9.94997 23.8848 9.94997C23.8688 9.94997 23.8201 9.99032 23.7766 10.0396ZM13.147 10.7077C12.3392 11.5657 11.7683 12.4714 11.3678 13.5303C11.2704 13.7878 11.2488 13.8783 11.2768 13.912C11.3264 13.9718 11.9918 14.2265 12.0451 14.206C12.0685 14.1971 12.1484 14.0687 12.2228 13.9208C12.6288 13.1133 13.335 12.243 14.0469 11.6725C14.189 11.5586 14.3055 11.4419 14.3057 11.4131C14.3061 11.3324 13.5307 10.4388 13.4602 10.4388C13.4272 10.4388 13.2863 10.5598 13.147 10.7077ZM25.5047 14.7254C24.7359 14.9459 24.0946 15.1459 24.0796 15.1699C24.0646 15.1939 24.0585 15.2354 24.0662 15.2623C24.0906 15.3477 24.1445 15.8215 24.1663 16.1423C24.1916 16.5137 24.1372 17.2132 24.0493 17.6466C24.0143 17.8197 23.9855 17.97 23.9855 17.9807C23.9855 17.9913 24.76 18 25.7067 18C27.0927 18 27.4394 17.9915 27.4874 17.9564C27.5432 17.9156 27.5459 17.864 27.5288 17.1661C27.5054 16.2058 27.4047 15.5257 27.1628 14.693C27.0707 14.3761 27.0368 14.3152 26.9555 14.3208C26.9263 14.3229 26.2735 14.5049 25.5047 14.7254ZM11.0181 14.749C10.9994 14.8073 10.958 15.0236 10.9259 15.2297C10.808 15.9877 10.8671 17.7738 11.016 17.9533C11.0597 18.0058 11.2655 18.0153 11.3402 17.9681C11.3803 17.9427 11.3898 17.8341 11.3932 17.3575C11.3991 16.5458 11.4952 15.8999 11.7207 15.1554C11.7797 14.9604 11.7967 14.8585 11.774 14.8358C11.7379 14.7996 11.1958 14.6431 11.1066 14.6431C11.0735 14.6431 11.0385 14.685 11.0181 14.749ZM18.4809 15.8861C19.0575 16.0791 19.0928 16.8692 18.5353 17.1022C18.2235 17.2324 17.8146 17.0611 17.6975 16.7513C17.647 16.6177 17.6551 16.3477 17.7132 16.2252C17.8502 15.9367 18.1873 15.7877 18.4809 15.8861Z",
    fill: "#E9BE5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_46_3996",
    x: 0.0133876,
    y: 0.0349245,
    width: 38.6775,
    height: 35.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.23254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_46_3996"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.352154,
    dy: 4.04977
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.16938
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_46_3996",
    result: "effect2_dropShadow_46_3996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_46_3996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_46_3996",
    x: 3.8185,
    y: 0.318499,
    width: 30.363,
    height: 27.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.09075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_46_3996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_46_3996",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.335615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167808
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_46_3996"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_46_3996",
    result: "effect3_innerShadow_46_3996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceDark);
export default __webpack_public_path__ + "static/media/performance-dark.5d474d6ef94c6edac624bcfa6e808d1e.svg";
export { ForwardRef as ReactComponent };